import { Input } from "@/components/ui/input";
import { lastDays } from "@/lib/loyalty";
import { cn } from "@/lib/utils";

const PRESETS = [[7, "7 dias"], [30, "30 dias"], [90, "90 dias"]];

export function PeriodPicker({ value, onChange }) {
  return (
    <div className="flex flex-wrap items-center gap-2" data-testid="loyalty-period">
      <div className="flex rounded-lg border p-1">
        {PRESETS.map(([n, label]) => {
          const p = lastDays(n);
          const on = p.start === value.start && p.end === value.end;
          return (
            <button key={n} onClick={() => onChange(p)} data-testid={`loyalty-period-${n}`}
              className={cn("rounded-md px-3 py-1.5 text-sm transition-colors", on ? "bg-primary text-primary-foreground" : "hover:bg-muted")}>{label}</button>
          );
        })}
      </div>
      <Input type="date" value={value.start} max={value.end} onChange={(e) => e.target.value && onChange({ ...value, start: e.target.value })} className="h-9 w-[150px]" data-testid="loyalty-period-start" />
      <span className="text-sm text-muted-foreground">até</span>
      <Input type="date" value={value.end} min={value.start} onChange={(e) => e.target.value && onChange({ ...value, end: e.target.value })} className="h-9 w-[150px]" data-testid="loyalty-period-end" />
    </div>
  );
}
